import React, { memo, useEffect, useState } from 'react';
import {
  loginWithGoogleEventEmitter,
  loginEventEmitter,
} from 'components/Login/Login';

import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';
import s from './TimelinePoll.scss';

// eslint-disable-next-line no-unused-vars
const PollSuccessLoginBlocker = ({ isWapView, hidePollMessage }) => {
  const [emailId, setEmailId] = useState('');
  const [inputMsg, setInputMsg] = useState('');
  const [loginBtnProcess, setLoginBtnProcess] = useState(false);

  useEffect(() => {
    analyticsWrapper('ga4', {
      event: 'user_shown',
      type: `poll_widget`,
      category: 'login_screen',
    });
  }, []);
  // const showLogin = () => {
  //   if (typeof props.toggleLoginBox === 'function') {
  //     if (typeof props?.ga4Type !== 'undefined' && props?.ga4Type !== '') {
  //       analyticsWrapper('ga4', {
  //         event: 'user_click',
  //         type: `${props?.ga4Type}`,
  //         category: 'login_to_view_results',
  //         msid: props?.msid,
  //         page_title: props?.hl,
  //         login_status: false,
  //       });
  //     }
  //     props.toggleLoginBox(true);
  //   }
  // };
  const loginWithGoogle = () => {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: `poll_widget`,
      category: 'google_login',
    });
    sessionStorage.setItem('previousPage', window.location.pathname);
    sessionStorage.setItem('poll_widget_GA', 1);
    loginWithGoogleEventEmitter();
  };

  const getValidEmailId = email => {
    const regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,6})$/;
    let emailAddress = '';
    if (regEmail.test(email)) {
      emailAddress = email;
    }

    return emailAddress;
  };
  const getValidMobileNumber = (mobile, withoutPrefix) => {
    const regMobile = withoutPrefix
      ? /^[6789]\d{9}$/
      : /^(\+91)?[0]?[6789]\d{9}$/;
    const notAllowedNumbers = [
      '6666666666',
      '7777777777',
      '8888888888',
      '9999999999',
    ];
    let mobileNo = '';
    if (regMobile.test(mobile)) {
      mobileNo = mobile.substring(mobile.length - 10, mobile.length);
    }

    if (notAllowedNumbers.indexOf(mobileNo) !== -1) {
      mobileNo = '';
    }

    return mobileNo;
  };

  const handleInputChange = val => {
    setEmailId(val);
    const checkIsEmail = val.indexOf('@');
    const checkIsMobile = !Number.isNaN(val) && val.length >= 10;
    let inputVal = '';
    if (checkIsEmail && getValidEmailId(val).length > 0) {
      inputVal = getValidEmailId(val);
    } else if (checkIsMobile && getValidMobileNumber(val).length > 0) {
      inputVal = getValidMobileNumber(val);
    }
    setLoginBtnProcess(false);
    if (inputVal.length > 0 && val.length > 0) {
      setLoginBtnProcess(true);
    }
  };

  const showEmailLogin = () => {
    const checkIsEmail = emailId.indexOf('@');
    const checkIsMobile = !Number.isNaN(emailId) && emailId.length >= 10;
    let inputVal = '';
    let loginType = '';
    setInputMsg('');
    if (checkIsEmail && getValidEmailId(emailId).length > 0) {
      loginType = 'email';
      inputVal = getValidEmailId(emailId);
    } else if (checkIsMobile && getValidMobileNumber(emailId).length > 0) {
      loginType = 'mobile';
      inputVal = getValidMobileNumber(emailId);
    }
    if (inputVal.length === 0 && emailId.length === 0) {
      setInputMsg('Email ID/Mobile No. cannot be left blank');
      return;
    } else if (!loginType) {
      setInputMsg('Please enter a valid Email ID/Mobile No.');
      return;
    }

    const preFill = emailId;
    sessionStorage.setItem('previousPage', window.location.pathname);
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: `poll_widget`,
      category: 'continue_manual_login',
    });
    sessionStorage.setItem('poll_widget_GA', 1);
    loginEventEmitter(undefined, {}, preFill);
    setTimeout(() => {
      if (document.getElementsByClassName('submit-btn')[0]) {
        document.getElementsByClassName('submit-btn')[0].click();
      }
    }, 1000);
  };

  return (
    <div className={`${s.wrap_poll} wrap_poll_as`}>
      {!hidePollMessage && (
        <div className={s.success_message}>
          <i />Vote has been Successfully Submitted!
        </div>
      )}
      <div
        className={`${s.poll_withoutLogin} ${
          s.poll_without_success
        } poll_withoutLogin  `}
      >
        <div className={s.inner}>
          <h4>Login to View The Results!</h4>
          <div className={s.login_options}>
            <div className={s.loginOptionWrap}>
              <button
                className={s.google}
                title="Google"
                onClick={loginWithGoogle}
              >
                <i /> Continue with Google
              </button>
            </div>
            <span>
              <i>or </i>
            </span>
            <div className={s.loginOptionWrap}>
              <input
                type="text"
                placeholder="Email ID/Mobile Number"
                value={emailId}
                className={`${inputMsg ? s.errorMsg : ''}`}
                onChange={e => handleInputChange(e.target.value)}
                onClick={() => {
                  if (isWapView) {
                    window.dispatchEvent(
                      new Event('TrueCallerLogin.openTrueCaller'),
                    );
                  }
                }}
              />
              {inputMsg && <div className="errorMsg">{inputMsg}</div>}
            </div>
          </div>

          {/* <button onClick={showLogin}>Login to view result</button> */}
          <div className={s.disclaimer_btn}>
            <div>
              By signing in or creating an account, you agree with our{' '}
              <a
                href="https://jssocdn.indiatimes.com/policy/termsandcondition.html"
                target="_blank"
                rel="noreferrer"
              >
                Terms and Conditions
              </a>{' '}
              and{' '}
              <a
                href="https://jssocdn.indiatimes.com/policy/privacypolicy.html"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>.
            </div>
            <button
              className={s.submit}
              onClick={showEmailLogin}
              disabled={!loginBtnProcess}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
PollSuccessLoginBlocker.propTypes = {
  //toggleLoginBox: PropTypes.bool.isRequired,
};
export default memo(PollSuccessLoginBlocker);
